
import { Component, Vue, Prop } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
    }),
  },
  methods: {
    ...mapActions({
      setSnackBarText: 'setSnackBarText',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      setOpenFileContent: 'setOpenFileContent',
    }),
  },
})
export default class OpenLocalConfigDialog extends Vue {
  @Prop(Boolean) dialogVisible!: boolean

  private file: any = null
  private fileContent: any = null
  private dialogHeader: string = 'Open local config (from JSON file)'

  private getDarkMode!: any[]

  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private setStartLoadingConfig!: (payload: boolean) => Promise<any>
  private setConfigLoaded!: (payload: boolean) => Promise<any>
  private setOpenFileContent!: (payload: any) => Promise<any>

  public okClicked() {
    //console.log(this.file)

    if (this.file == null) {
      this.setSnackBarText({
        snackBarText: 'Choose the local JSON configuration first!',
        snackBarColor: 'red',
      })
      return false
    }
    this.setStartLoadingConfig(true)
    this.setConfigLoaded(false)

    var reader = new FileReader()

    // Use the javascript reader object to load the contents
    // of the file in the v-model prop
    reader.readAsText(this.file)
    reader.onload = () => {
      this.fileContent = reader.result
      //console.log(this.fileContent)
      this.setOpenFileContent(this.fileContent)
    }

    this.$emit('update:dialogVisible', false)
  }

  public cancelClicked() {
    this.$emit('update:dialogVisible', false)
    //console.log('CANCEL CLICKED')
  }
}
